import animateScrollTo from 'animated-scroll-to'

const anchorNav = () => {

    const anchorNav = document.querySelector('.anchorNav')
    const anchorNavLinks = document.querySelectorAll('.anchorNav__listLink')
    let isAnimating

    /**
     * Remove active state
     */
    const clearAnchorNavStates = () => {
        Array.from(anchorNavLinks).forEach((elLink) => {
            elLink.classList.remove('-active')
        })
    }

    /**
     * Add active state to jump link
     * @param entries {array}
     */
    const updateAnchorNavLinkStates = (entries) => {
        const [entry] = entries
        if (entry.isIntersecting) {
            // only update if scrolling manually
            if (!isAnimating) {
                const targetLink = anchorNav.querySelector(
                    `[href="#${entry.target.id}"]`
                )

                if (targetLink) {
                    clearAnchorNavStates()
                    targetLink.classList.add('-active')
                }
            }
        }
    }


    if (anchorNav) {
        const sections = document.querySelectorAll('.section[id]')

        anchorNavLinks.forEach((anchorNavLink) => {
            anchorNavLink.addEventListener('click', function(e) {
                e.preventDefault()
                const section = document.getElementById(anchorNavLink.getAttribute('href').replace('#', ''))

                clearAnchorNavStates()

                this.classList.add('-active')

                isAnimating = true

                animateScrollTo(section).then(hasScrolledToPosition => {
                    if (hasScrolledToPosition) {
                        isAnimating = false
                    }
                });
            })
        })


        /**
         * Update anchor nav active states when new sections come into view
         */
        sections.forEach((section) => {
            const observer = new IntersectionObserver(updateAnchorNavLinkStates, {
                threshold: 0.3,
            })

            observer.observe(section)
        })

    }
}

export default anchorNav
